<p-dialog #dialog [header]="(disable==true? 'SaleRecord.TitleView':'SaleRecord.TitleEdit' )| translate"
  [(visible)]="isShow" [modal]="true" [styleClass]="'ag-modal force-full-width'" [style]="{'width': '1200px'}"
  closeIcon="ci ci-close" maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true"
  [autoZIndex]="true">
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>

      <p-accordion [multiple]="true" [activeIndex]="[0,1]">
        <p-accordionTab header="Thông tin của khách hàng">
        <div class="col-12 md:col-12 p-fluid p-formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="nameUser">{{'SaleRecord.NameUser' | translate}}<span style="color: red;">*</span></label>
            <input type="text" pInputText [(ngModel)]="itemDetail.nameUser" autocomplete="off" formControlName="nameUser"
              [readonly]="disable">
          </div>
          <div class="field col-12 md:col-6">
            <label for="birthDay">{{'SaleRecord.BirthDay' | translate}}<span style="color: red;">*</span></label>
            <p-calendar formControlName="birthDay" [(ngModel)]="itemDetail.birthDay" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy"
              [disabled]="disable" />
          </div>
          <div class="field col-12 md:col-6">
            <label for="gender">{{'SaleRecord.Gender' | translate}}</label>
            <p-dropdown [options]="listGender" [(ngModel)]="itemDetail.gender" [filter]="true" filterBy="label,value"
              appendTo="body" [virtualScroll]="true" formControlName="gender" [readonly]="disable">
            </p-dropdown>
          </div>
          <div class="field col-12 md:col-6">
            <label for="phone">{{'SaleRecord.Phone' | translate}}<span style="color: red;">*</span></label>
            <input type="text" pInputText [(ngModel)]="itemDetail.phone" formControlName="phone" autocomplete="off"
              [readonly]="disable">
          </div>
          <div class="field col-12 md:col-6">
            <label for="ethnic">{{'SaleRecord.Ethnic' | translate}}</label>
            <p-dropdown [options]="listEthnic" [(ngModel)]="itemDetail.ethnic" [filter]="true" filterBy="label,value" appendTo="body"  [readonly]="disable"
            formControlName="ethnic">
           </p-dropdown>
          </div>
          <div class="field col-12 md:col-6">
            <label for="citizenId">{{'SaleRecord.CitizenId' | translate}}<span style="color: red;">*</span></label>
            <input type="text" pInputText [(ngModel)]="itemDetail.citizenId" formControlName="citizenId"
              autocomplete="off" [readonly]="disable">
          </div>
          <div class="field col-12 md:col-6">
            <label for="dateRange">{{'SaleRecord.DateRange' | translate}}</label>
            <p-calendar formControlName="dateRange" [(ngModel)]="itemDetail.dateRange" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy"
              [disabled]="disable" />
          </div>
          <div class="field col-12 md:col-6">
            <label for="issuedBy">{{'SaleRecord.IssuedBy' | translate}}</label>
            <input type="text" pInputText [(ngModel)]="itemDetail.issuedBy" formControlName="issuedBy" autocomplete="off"
              [readonly]="disable">
          </div>
          <div class="field col-12 md:col-12">
            <label for="address">{{'SaleRecord.Address' | translate}}</label>
            <input type="text" pInputText [(ngModel)]="itemDetail.address" autocomplete="off" [readonly]="disable"
              formControlName="address">
          </div>
        </div>
        </p-accordionTab>
        <p-accordionTab header="Thông tin hồ sơ bán hàng">
          <div class="col-12 md:col-12 p-fluid p-formgrid grid">
            <div class="field col-12 md:col-6">
              <label for="code">{{'SaleRecord.ReferenceCode' | translate}}<span style="color: red;">*</span></label>
              <input type="text" pInputText [(ngModel)]="itemDetail.code" formControlName="code" [readonly]="true">
            </div>
            <div class="field col-12 md:col-6">
              <label for="contractCode">{{'SaleRecord.Code' | translate}}<span style="color: red;">*</span></label>
              <input type="text" pInputText [(ngModel)]="itemDetail.contractCode" formControlName="contractCode"
                [readonly]="true">
            </div>
            <div class="field col-12 md:col-6">
              <label for="categoryId">{{'SaleRecord.TypeService' | translate}}<span style="color: red;">*</span></label>
              <p-dropdown [options]="listCategory" [(ngModel)]="itemDetail.categoryId" [filter]="true"
                filterBy="label,value" appendTo="body" formControlName="categoryId"
                [readonly]="true">
              </p-dropdown>
            </div>
            <div class="field col-12 md:col-6">
              <label for="startDate">{{'SaleRecord.StartDate' | translate}}<span style="color: red;">*</span></label>
              <p-calendar formControlName="startDate" [(ngModel)]="itemDetail.startDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy"
                [disabled]="true" />
            </div>
            <div class="field col-12 md:col-6">
              <label for="productId">{{'SaleRecord.ProductCode' | translate}}<span style="color: red;">*</span></label>
              <p-dropdown [options]="listProduct" [(ngModel)]="itemDetail.productId" [filter]="true"
                filterBy="label,value" appendTo="body" formControlName="productId"
                [readonly]="true">
              </p-dropdown>
            </div>
            <div class="field col-12 md:col-6">
              <label for="endDate">{{'SaleRecord.EndDate' | translate}}<span style="color: red;">*</span></label>
              <p-calendar formControlName="endDate" [(ngModel)]="itemDetail.endDate" icon="ci ci-calendar" dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy"
                [disabled]="true" />
            </div>
            <div class="field col-12 md:col-6">
              <label for="salesNumber">{{'SaleRecord.SalesNumber' | translate}}<span style="color: red;">*</span></label>
                <p-inputNumber  [(ngModel)]="itemDetail.salesNumber" formControlName="salesNumber"inputId="locale-us" [readonly]="disable" (onBlur)="onEnterSaleNumber()"
                mode="decimal" locale="en-US"  [maxFractionDigits]="0" /> 
            </div>
            <div class="field col-12 md:col-6">
              <label for="revenue">{{'SaleRecord.Revenue' | translate}}</label>
              <p-inputNumber  [(ngModel)]="itemDetail.revenue" formControlName="revenue"inputId="locale-us"  [readonly]="true"
                mode="decimal" locale="en-US"  [maxFractionDigits]="0" />
            </div>
            <div class="field col-12 md:col-4">
              <label for="totalRemuneration">{{'SaleRecord.TotalRemuneration' | translate}}</label>
              <p-inputNumber  [(ngModel)]="itemDetail.totalRemuneration" formControlName="totalRemuneration"inputId="locale-us"  [readonly]="true"
              mode="decimal" locale="en-US"  [maxFractionDigits]="0" /> 
            </div>
            <div class="field col-12 md:col-4">
              <label for="remunerationReceived">{{'SaleRecord.RemunerationReceived' | translate}}</label>
              <p-inputNumber  [(ngModel)]="itemDetail.remunerationReceived" formControlName="remunerationReceived"inputId="locale-us"  [readonly]="true"
              mode="decimal" locale="en-US"  [maxFractionDigits]="0" /> 
            </div>
            <div class="field col-12 md:col-4">
              <label for="adjust">{{'SaleRecord.Adjust' | translate}}</label>
              <p-inputNumber  [(ngModel)]="itemDetail.adjust" formControlName="adjust"inputId="locale-us"  [readonly]="disable"
                mode="decimal" locale="en-US"  [maxFractionDigits]="0" /> 
            </div>
            <div class="field col-12 md:col-6">
              <label for="userCode">{{'SaleRecord.UserCode' | translate}}</label>
              <p-dropdown [options]="listUser" [(ngModel)]="itemDetail.userCode" [filter]="true" filterBy="label,value"
                appendTo="body" [readonly]="disable" [virtualScroll]="true" [virtualScrollItemSize]="10" formControlName="userCode">
              </p-dropdown>
            </div>
            <div class="field col-12 md:col-6">
              <label for="actuallyReceived">{{'SaleRecord.ActuallyReceived' | translate}}</label>
              <p-inputNumber  [(ngModel)]="itemDetail.actuallyReceived" formControlName="actuallyReceived"inputId="locale-us"  autocomplete="off"  [readonly]="disable"
                mode="decimal" locale="en-US"  [maxFractionDigits]="0" /> 
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </form>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left">
      </div>
      <div class="col-4 md:col-4 fr" *ngIf="!disable">
        <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CLOSE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"></button>

        <!-- <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CONTINUE' | translate}}" icon="pi pi-save"
          *ngIf="itemDetail.id == 0" [disabled]="submitting" class="p-button mr-2 mb-2" (click)="save()"
          authorize="[{'core':'users/1'}]"></button> -->
      </div>
    </div>
  </p-footer>
</p-dialog>